/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import moment from 'moment';


class DataHelperClass {
    constructor() {
        this.DateDisplayFmt = "DD-MMM-YYYY";
        this.DateTimeDisplayFmt = "DD-MMM-YYYY HH:mm";
    }

    dbDateToDisplayTime(t) {
        var tx = moment(t);
        return tx.format(this.DateDisplayFmt);
    }

    dbTimeToDisplayTime(t) {
        var tx = moment(t);
        return tx.format(this.DateTimeDisplayFmt);
    }

    deepCopy(obj) {
        var cs = JSON.stringify(obj) ;
        return JSON.parse(cs);
    }

    undefinedFromEmptyString(v) {
        if (v === null || v === undefined) {
            return undefined ;
        }

        return v === "" ? undefined : v ;
    }

    byteString(n) {
        if (n < 0 || n > 255 || n % 1 !== 0) {
            throw new Error(n + " does not fit in a byte");
        }
        return ("000000000" + n.toString(2)).substr(-8)
    }

    bitFieldSetForByte(type,offset,value) {
        let bf = DataHelper.byteString(value) ;

        var result = {};
        for (var c = 7 ; c >= 0; c--) {
            let idx = c + (offset * 8);
            result[type + idx] = bf[c];
        }
        return result ;
    }


    bitFieldSetForByteWithTarget(type,offset,value,target) {
        var bf = DataHelper.byteString(value) ;

        for (var c = 7 ; c >= 0; c--) {
            var idx = c + (offset * 8);
            target[type + idx] = bf[7 - c];
        }
    }

    pinLedColourClass(pin) {
        if (!pin || !pin.led) {
            return "pinLedOff";
        }

        switch (pin.led) {
            case "R" : return "pinLedRed";
            case "G" : return "pinLedGreen" ;
            case "Y" : return "pinLedYellow";
            case "O" : return "pinLedOrange" ;
            default: return "pinLedOff";
        }
    }

}

const DataHelper = new DataHelperClass();
export default DataHelper;


//  <row> 
//         <mode>128</mode> 
//         <hardware>v1-01</hardware> 
//         <firmware>v0-13</firmware> 
//         <job>Showroom Gearless</job> 
//         <mac>00-1e-c0-14-32-cf</mac> 
//         <min0>64</min0> 
//         <min1>24</min1> 
//         <min2>158</min2> 
//         <mout0>0</mout0> 
//         <mout1>64</mout1> 
//         <mout2>0</mout2> 
//         <trip>2338</trip> 
//         <pot>03020</pot> 
//         <client>Savaria SIS</client> 
//     </row>






// WEBPACK FOOTER //
// ./src/app/library/DataHelpers.js